export default {
    task: {
        getMyCash: 'मेरा कैश पाएं',
        chances: 'अवसर शेष',
        tips: 'कार्ड पाने के लिए सुझाव',
        daily: 'प्रतिदिन चेक-इन',
        watch: 'कोई भी वीडियो देखें',
        share: 'प्रतियोगिता साझा करें',
        free: 'नि:शुल्क कैश एवं कार्ड +1',
        done: 'संपन्न',
        go: 'शुरू करें',
        success: 'सफलतापूर्वक',
        checkIn: 'प्रवेश सुनिश्चित',
        successCheckIn: 'सफलतापूर्वक चेक-इन हुआ!',
        successWatched: 'सफलतापूर्वक देखे हैं!',
        successShared: 'सफलतापूर्वक साझा किए!',
        won: 'आप जीते',
        card: 'कार्ड',
        msg: 'पैसा आपके खाते में भेज दिया गया है',
        ok: 'ठीक है',
        nochance: 'आपने पूरा समाप्त नहीं किया है',
        cards: '4-कार्ड',
        collection:'संग्रह',
        watchVideo:'वीडियो देखें ',
        toGet:'अधिक कार्ड प्राप्त करने के लिए'
    },
    
    rules: {
        ruleTitle: "नियम",
        validityDate: "वैधता तिथि: 8 मार्च, 2020 - 15 मार्च 2020",
        prizeRedeem: "पुरस्कार रिडीम करें: उपयोगकर्ता का बैलेन्स रु 15 पहुंच जाने पर वे अपना धन आहरण कर सकते हैं, ट्रांजैक्शन 7 कार्यदिवसों के अन्दर पूरी हो जाएगी",
        gameRule:{
            title:"गेम के नियम:",
            ruleList: [
                "1. प्रतिदिन चेक-इन करने पर उपयोगकर्ताओं को कैश एवं 1 कार्ड मिल सकता है",
                "2. प्रतिदिन कोई वीडियो देखने पर उपयोगकर्ताओं को कैश एवं 1 कार्ड मिल सकता है ",
                "3. अपनी गतिविधि को WhatsApp ग्रुप या Facebook या Instagram या ऐसे ही मंचों पर साझा करने पर उपयोगकर्ताओं को कैश एवं 1 कार्ड मिल सकता है",
                "4. सभी 4 कार्ड कलेक्ट हो जाने पर उपयोगकर्ताओं को एक लॉटरी ड्रॉ करने का मौका मिल सकता है। प्रत्येक लकी ड्रॉ एक 100%-सुनिश्चित-जीत वाला लकी ड्रॉ है, इसमें 3 मिलियन अर्थात तीस लाख रुपए का धनसंग्रह है, जिसमें से प्रत्येक उपयोगकर्ता अधिकतम रु 20000 ड्रॉ कर सकता है।"
            ]
        },
        msg:"SHAREit अंतिम निर्णय का अधिकार सुरक्षित रखता है"
    },
    share: {
        title:"*मित्र, ये मजाक नहीं है, इस होली SHAREit दे रहा है 30 लाख असली कैश !*😊\n*मुझसे जुड़ें और वीडियो देखें और पाएं रु 20000 तक, सभी लोगों की 100% जीत।*💰\n*मुझे पहले ही नकद कैश मिल चुका है, यह 100% सही है।*\n*आइए SHAREit होली प्रतियोगिता में अभी शामिल हों!*💕👇🏻👇🏻👇🏻"
    }
}